/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Audio_Recorder_Duration_ValueInputs */



/**
* | output |
* | --- |
* | "{seconds}s" |
*
* @param {Audio_Recorder_Duration_ValueInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_duration_value = /** @type {((inputs: Audio_Recorder_Duration_ValueInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Duration_ValueInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.seconds}s`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.seconds}s`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.seconds}s`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.seconds}s`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.seconds}s`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.seconds}s`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.seconds}s`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.seconds}s`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.seconds}s`)
	return /** @type {LocalizedString} */ (`${i?.seconds}s`)
});